<template>
  <div>
    <div class="row justify-content-center" style="width: 100%">
      <div class="input-group search-job-input-field" style="max-width: 70rem">
        <input
          v-model="search"
          type="text"
          class="form-control"
          @keyup.enter="submit"
          placeholder="Search applicants"
        />
        <div @click="submit" class="input-group-append">
          <div class="find-jobs-button" align="middle">
            <!-- <v-icon style="color:white;font-size:2.5rem" v-if="phone"
              >search</v-icon> -->
            <b>SEARCH</b>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center align-items-center" style="padding-top:2rem">
      <div :class="{pass:active,act:!active}" @click="getData">
        Campus Ambassador Request(s)
      </div>
      /
      <div :class="{pass:!active,act:active}" @click="getDataAmb">
        Accepted Campus Ambassador
      </div>
    </div>
    <table>
      <tr>
        <th>Applied time</th>
        <th>Email</th>
        <th>Name</th>
        <!-- <th>Institute</th>
        <th>Phone</th> -->
        <th v-if="!active">Ref code</th>
        <th v-if="!active">Total Referred candidates</th>
        <!-- <th>Action</th> -->
      </tr>
      <tr v-for="amb in filteredLog" :key="amb.email">
        <td>{{ (new Date(amb.time) + "").substring(0, 15) }}</td>
        <td>
          {{ amb.email }}
          <span
            style="color: var(--link-color); cursor: pointer; margin-left: 1rem"
            @click="ViewCandidate(amb)"
            >View Application</span
          >
        </td>
        <td>{{ amb.name }}</td>
        <!-- <td>{{ amb.institute }}</td>
        <td>{{ amb.phone }}</td> -->
        <td>
          {{ amb.refCode }}
          <span
            v-if="amb.refCode&&!active"
            style="color: var(--link-color); cursor: pointer; margin-left: 1rem"
            @click="copyToClipboard(amb.refCode)"
            >get link</span
          >
        </td>
        <td v-if="!active">{{ amb.referred }}</td>

        <!-- <td class="row">
          <button v-if="!amb.refCode" class="btn-save" @click="accept(amb)">
            Accept
          </button>
          <button
            class="btn-outline"
            style="margin-left: 1rem"
            @click="remove(amb)"
          >
            Remove
          </button>
        </td> -->
      </tr>
    </table>
    <v-dialog v-model="openbox" width="1000px">
      <view-profile :id="user_id" :key="change"> </view-profile>
    </v-dialog>
    <v-dialog v-model="openbox2" width="1000px">
      <div
        style="background-color: white; padding: 2rem"
        align="left"
        v-if="showData"
      >
        <div
          style="color: var(--link-color); cursor: pointer"
          @click="viewWorkd"
        >
          View workd profile
        </div>
        <div class="header" v-show="showData.email">Email</div>
        <div class="body">{{ showData.email }}</div>
        <div class="header" v-show="showData.name">Name</div>
        <div class="body">{{ showData.name }}</div>
        <div class="header" v-show="showData.institute">Institute</div>
        <div class="body">{{ showData.institute }}</div>
        <div class="header" v-show="showData.phone">Phone</div>
        <div class="body">{{ showData.phone }}</div>
        <div class="header" v-show="showData.fblink">Facebook Profile</div>
        <div class="body">
          <a :href="showData.fblink" target="_blank">{{ showData.fblink }}</a>
        </div>
        <div class="header" v-show="showData.extra">
          Extracurricular activities
        </div>
        <div class="body">{{ showData.extra }}</div>
        <div class="header" v-show="showData.clubs">Clubs</div>
        <div class="body">{{ showData.clubs }}</div>
        <div class="row" style="margin-top: 4rem !important">
          <button
            v-if="!showData.refCode&&!loading"
            class="btn-save"
            @click="accept(showData)"
          >
            Accept
          </button>
          <button
            v-if="!loading&&active"
            class="btn-outline"
            style="margin-left: 1rem"
            @click="remove(showData)"
          >
            Remove
          </button>
        </div>
      </div>
    </v-dialog>
    <v-snackbar :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">Copied to clipboard</div>
    </v-snackbar>
    <div id="copy"></div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { getUrl,getBase } from "../../../globalConstants";
import { randomString } from "../../../globalFunctions";
import "firebase/database";
import { CANDIDATE_DETAILS } from "../../../Api/employer_api";
import viewProfile from "../view/view-profile";
export default {
  components: { viewProfile },
  data: function () {
    return {
      search: "",
      allLog: [],
      filteredLog: [],
      timeOut: 1000,
      snackbar: false,
      user_id: "",
      change: 0,
      openbox: false,
      openbox2: false,
      showData: null,
      active:true,
      base:getBase()
    };
  },
  methods: {
    accept(val) {
      this.addToFirebase(val);
    },
    viewWorkd() {
      this.user_id = this.showData.uid;
      this.change++;
      this.openbox = true;
    },
    ViewCandidate(val) {
      this.showData = val;
      this.user_id = val.uid;

      this.openbox2 = true;
    },
    addToFirebase(val) {
      this.loading = true;
      let database = firebase.database();
      let data = {
        uid: val.uid,
      };
      let ref = randomString(6);
      val.refCode = ref;
      database
        .ref(this.base+"/campusRef/" + ref)
        .set(data)
        .then((res) => {
          return database.ref(this.base+"/campAmb/" + val.uid).set(val);
        })
        .then((res) => {
          return database.ref(this.base+"/campus").child(val.uid).remove();
        })
        .then((res)=>{this.openbox2=false;this.loading = false;})
        .catch();
    },
    remove(val) {
      this.loading = true;
      let database = firebase.database();
      database
        .ref(this.base+"/campus")
        .child(val.uid)
        .remove()
        .then((resp) => {
          if (val.refCode)
            return database.ref(this.base+"/campusRef").child(val.refCode).remove();
          else return true;
        })
        .then((val) => (this.loading = false))
        .catch();
    },
    submit() {
      if (this.search === "refresh") this.getData();
      else if (this.search === "") this.filteredLog = this.allLog;
      else
        this.filteredLog = this.allLog.filter(
          (val) =>
            val.email === this.search ||
            (val.institute &&
              val.institute.toLowerCase() === this.search.toLowerCase()) ||
            (val.name &&
              val.name.toLowerCase() === this.search.toLowerCase()) ||
            (val.phone && val.phone + "" === this.search) ||
            (val.refCode && val.refCode + "" === this.search)
        );
    },
    getData() {
      this.active=true
      firebase
        .database()
        .ref(this.base+"/campus")
        .orderByChild("time")
        .on("value", (val) => {
          let temp = []
          console.log(val)
          val.forEach((child) => {
            let item = child.val();
            temp.unshift(item);
          });
          temp=temp.sort((a,b)=>a.time>b.time)
          this.allLog = temp;
          this.filteredLog = temp;
        });
    },
    getDataAmb() {
      this.active=false
      firebase
        .database()
        .ref(this.base+"/campAmb")
        .orderByChild("time")
        .on("value", (val) => {
          let temp = [];
          val.forEach((child) => {
            let item = child.val();
            temp.unshift(item);
          });
          temp=temp.sort((a,b)=>a.time>b.time)
          this.allLog = temp;
          this.filteredLog = temp;
        });
    },
    copyToClipboard(refCode) {
      const el = document.createElement("textarea");
      el.value = getUrl() + "/signin/" + refCode;
      document.getElementById("copy").appendChild(el);
      el.select();
      document.execCommand("copy");
      document.getElementById("copy").removeChild(el);
      this.snackbar = true;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.form-control {
  padding-left: 2.5rem;
  max-width: 79.8rem;
  height: 6.1rem;
  position: relative;
  border-radius: 1rem !important;
  border: 1px solid #c5c5c5 !important;
  background-color: #fff !important;
  font-size: 2rem;
}
.form-control:focus {
  box-shadow: none !important;
  /*outline: none !important;*/
  /*border: none !important;*/
}
.find-jobs-button {
  margin-left: -17rem;
  cursor: pointer;
  width: 14.6rem;
  height: 4.2rem;
  border-radius: 2.4rem;
  background-color: var(--button-color);
  color: white;
  z-index: 80;
  font-size: 1.6rem;
  font-weight: 100;
  line-height: 1.5;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
}
.header {
  font-weight: bold;
  color: black;
  margin-top: 2rem;
}
.body {
  color: grey;
}
table {
  margin: 5rem 0;
  font-family: arial, sans-serif;
  border-collapse: separate;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
  border-radius: 0.4rem;
}

tr:nth-child(even) {
  background-color: #ebebeb;
}
.act{
  cursor: pointer;
  color:var(--link-color);
  font-weight: bold;
  font-size:1.6rem;
  text-decoration: underline;
  padding: 0 1rem;
}
.pass{
  color:black;
  cursor: pointer;
  font-weight: bold;
  font-size:1.6rem;
  padding: 0 1rem;
}
.pass:hover{
  text-decoration: underline
}
.amb-card {
  border: 1px solid #cccccc;
  padding: 2rem;
  border-radius: 2rem;
  margin: 2rem;
  float: left;
  text-align: left;
}
.amb-card > h1 {
  font-size: 2rem;
  font-weight: bold;
}
.amb-card > h2 {
  font-size: 1.8rem;
  color: grey;
  font-weight: bold;
}
</style>